<!DOCTYPE html>
<html lang="en" xml:lang="en">
  <head>
    <title>Device Configuration Added Successfully</title>
  </head>
  <body>
    <div>
      <div class="error-container">
        <h1>Device configuration added to device configuration inventory</h1>
        <div class="error-message" style="color: #b1b1b1">
          Can check in device configuartion inventory, for redirection click
          below button!
        </div>
        <div>
          <a
            href="admin/device/configuration"
            class="btn btn btn-lg"
            style="background-color: #21293a; color: #ffffff"
            >Inventory</a
          >
        </div>
      </div>
    </div>
  </body>
</html>
